import React, { ReactNode } from 'react';

import { IInjectionContext, InjectionContext } from './context';

interface IInjectionProviderProps extends IInjectionContext {
  children: ReactNode | ReactNode[];
}

function InjectionProvider({ container, children }: IInjectionProviderProps) {
  return <InjectionContext.Provider value={{ container }}>{children}</InjectionContext.Provider>;
}

export default InjectionProvider;
